// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1peyf","img":"Header_img__25tBV"};